// Module
var code = `<div class="js-tercera-label {{additionalClass}}"
     {{^enabled}}disabled="" {{/}}
     style="{{>visibility}}{{style}} {{#if isPosAbsolute}}position: absolute; {{>position}}{{/if}}">
    {{{innerHTML}}}
</div>`;
// Exports
export default code;